/* import __COLOCATED_TEMPLATE__ from './empty-state.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {};
  Element: HTMLDivElement;
  Blocks: {};
}

const ScimEmptyState = templateOnlyComponent<Signature>();
export default ScimEmptyState;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Teammates::Scim::EmptyState': typeof ScimEmptyState;
    'new-settings/workspace/teammates/scim/empty-state': typeof ScimEmptyState;
  }
}
